import { render } from "./ChartsDataConfigor.vue?vue&type=template&id=006570de&scoped=true"
import script from "./ChartsDataConfigor.vue?vue&type=script&lang=js"
export * from "./ChartsDataConfigor.vue?vue&type=script&lang=js"

import "./ChartsDataConfigor.vue?vue&type=style&index=0&id=006570de&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006570de"]])

export default __exports__